import crypto from 'crypto-browserify';

const key = process.env.REACT_APP_CRYPTO_KEY;

const getSignature = (plaintext: string) => {
  if (!key) return;
  const initializationVector = crypto.randomBytes(16);
  const cipher = crypto.createCipheriv(
    'aes-256-cbc',
    Buffer.from(key),
    initializationVector
  );
  let encrypted = cipher.update(plaintext, 'utf-8', 'base64');
  encrypted += cipher.final('base64');
  return initializationVector.toString('base64') + encrypted;
};

export const getAuthenticationHeaders = (path) => {
  const time = Math.round(new Date().getTime() / 1000);
  const payload = { path, time };
  const serializedPayload = JSON.stringify(payload);
  const signature = getSignature(serializedPayload);
  return {
    Authentication: signature,
  };
};
